import CTAHover from '../../components/ui/CTAHover';
import { useTranslation } from 'react-i18next';

// Section: All you need in one place — search, analyse, add to CRM, track status
// Layout: two columns (text + single centered image)

const HeadingSection1 = ({ bgColor = 'bg-white' }) => {
  const { t } = useTranslation();

  return (
    <section className={`py-24 ${bgColor}`}>
      <div className="w-[75%] gap-32 items-center mx-auto max-w-screen-xl lg:grid lg:grid-cols-2">
        {/* Left column: text */}
        <div>
          <h3 className="text-2xl text-blue-600 font-bold mb-4">
            {t('pageHome.content.t66')}
          </h3>
          <h2 className="text-4xl ">
            {t('pageHome.content.t67')}
          </h2>

          <p className="mt-6 text-base ">
            {t('pageHome.content.t68')}
          </p>
          <p className="mt-6 text-base ">
            {t('pageHome.content.t69')}
          </p>

          <CTAHover
            className="mt-6"
            text={t('pageHome.content.t70')}
            href="find-investors"
            align="left"
            bgColor="bg-blue-600 text-white"
            textColor="text-stone-700"
            hoverTextColor="text-white"
          />
        </div>

        {/* Right column: one centered image */}
        <div className="mt-16 lg:mt-0 flex justify-center items-center">
          <img
            className="w-[65%] border max-w-sm rounded-lg"
            src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/homepage-research-add-to-crm.webp"
            alt="Platform dashboard preview"
          />
        </div>
      </div>
    </section>
  );
};

export default HeadingSection1;
